export const flightConformanceParsedStates = [
    {
        name: 'No Breaches',
        value: 'NO_BREACHES'
    },
    {
        name: 'No Policy',
        value: 'NO_POLICY'
    },
    {
        name: 'Breaches',
        value: 'BREACHES'
    }
];

export const ConformaceStatusGroups = Object.freeze([
    'NO_BREACHES',
    'NO_POLICY',
    'BREACHES'
] as const);

export type ConformaceStatusGroup = typeof ConformaceStatusGroups[number];
